import Button from '../../../../../components/Button';
import styles from './style.module.scss';
import MotionWrapper from '../../../../../containers/MotionWrapper';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from '../../../../../store/store';
import { setMultipleChoiceExamStep } from '../../../../../store/exam/slice';
import { MultipleChoiceExamEndIllustration } from '../../../../../assets/illustrations';

function ExamEnd() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const navigation = () => {
        dispatch(setMultipleChoiceExamStep('KYC'));
        navigate('/workspace');
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <MultipleChoiceExamEndIllustration />
            <span className={styles.title}>Well done!</span>
            <span className={styles.text}>You finished the exam.</span>
            <Button
                type='Primary'
                onClick={navigation}
                text='Go to dashboard'
                className={styles.navigate}
            />
        </MotionWrapper>
    )
};

export default ExamEnd;
